import { render, staticRenderFns } from "./AboutWeAre.vue?vue&type=template&id=5fa662d3"
import script from "./AboutWeAre.vue?vue&type=script&lang=js"
export * from "./AboutWeAre.vue?vue&type=script&lang=js"
import style0 from "./AboutWeAre.vue?vue&type=style&index=0&id=5fa662d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports